<script lang="ts">
	import { LabelListV2 } from '@Shelly/shelly-design-system';
	import type { LabelV2Props } from '@Shelly/shelly-design-system';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';
	import { shouldHideLabelsAndCharts } from 'src/components/Sidepanel/device-view-state-context';

	export let labelList: LabelV2Props[] = [];
	export let backgroundColor: LabelV2Props['backgroundColor'] = '--color-0';
	export let isInteractive: boolean = true;

	let className = '';
	export { className as class };
</script>

{#if labelList?.length > 0 && !shouldHideLabelsAndCharts()}
	<div class="lable-list-wrapper-in-drawer-tab-content mb-s {className}">
		<LabelListV2
			{backgroundColor}
			labelList={labelList.map((el) => ({
				...el,
				icon: mapIconSolidWeightToLight(el?.icon),
			})) || []}
			size="m"
			data-prevent-drawer-swipe
			data-prevent-sidepanel-swipe
			isDefaultCursor
			a11yProps={{ isInteractive }}
			on:label-click={(e) => {
				e.stopPropagation();
			}}
		/>
	</div>
{/if}
